module.exports = __webpack_public_path__ + "img/3d_jp.3267300.jpg";